import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ScreenService } from '../screen.service';
import { retry } from 'rxjs/operators';

@Injectable()
export class ApiService {
  public bearerToken: string;
  public currentUser: any;
  loading = false;

  constructor(
    private http: HttpClient,
    private screenService: ScreenService
  ) { }

  setHeaders(headerType, authenticate) {
    const headersConf = {};
    if (headerType === 'json') {
      headersConf['Content-Type'] = 'application/json';
    } else if (headerType === 'json-x') {
      headersConf['Content-Type'] = 'application/json';
    } else if (headerType === 'form') {
      headersConf['Content-Type'] = 'application/x-www-form-urlencoded';
    } else if (headerType === 'multipart') {
      headersConf['Content-Type'] = 'multipart/form-data';
    }
    // Authkey
    // Authorization
    if (authenticate) {
      const screen = this.screenService.getScreenFromLocalStorage();
      if (screen) {
        headersConf['X-SignalR-AuthKey'] = screen.authKey;
      }
    }
    return new HttpHeaders(headersConf);
  }

  get(path: string, headerType: string, authenticate: boolean): Observable<any> {
    const headers = this.setHeaders(headerType, authenticate);
    return this.http.get(environment.api_url + path, { headers }).pipe(retry(2));
  }

  getLocal(path: string, headerType: string, authenticate: boolean): Observable<any> {
    const headers = this.setHeaders(headerType, authenticate);
    return this.http.get(path, { headers }).pipe(retry(2));
  }

  patch(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    const headers = this.setHeaders(headerType, authenticate);
    return this.http.patch(environment.api_url + path, body, { headers }).pipe(retry(2));
  }

  post(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    const headers = this.setHeaders(headerType, authenticate);
    return this.http.post(environment.api_url + path, body, { headers }).pipe(retry(2));
  }

  put(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    const headers = this.setHeaders(headerType, authenticate);
    return this.http.put(environment.api_url + path, body, { headers }).pipe(retry(2));
  }

  delete(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    const headers = this.setHeaders(headerType, authenticate);
    return this.http.delete(environment.api_url + path, { headers }).pipe(retry(2));
  }

}
